import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=94dbc376&scoped=true"
var script = {}
import style0 from "./Content.vue?vue&type=style&index=0&id=94dbc376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dbc376",
  null
  
)

export default component.exports